import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import { academylist, listhostelentry } from "../../../services/admin";

// Read-only hostel report. Filter by academy (super-admin) and hostel type
// (Boys/Girls); the matching hostel residents (students/teachers) are shown in
// an ag-grid table and can be exported to CSV. Mirrors the other report screens.
const roleLabel = (id) =>
  id === 4 ? "Student" : id === 5 ? "Teacher" : "";

const HostelReport = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [htype, setHType] = useState("");
  const [rowData, setRowData] = useState([]);

  const columnDefs = [
    { headerName: "Hostel", field: "hostel_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Room No", field: "room_no", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Type", field: "hostel_type", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Role", field: "role", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Username", field: "username", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Name", field: "student_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Class", field: "class_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Academy", field: "academy_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
  ];

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.code,
        }));
        setACList(arr);

        // Default to the academy chosen at login (matches other report screens).
        let defaultAca = "";
        if (localStorage.getItem("AAcademy") != null) {
          defaultAca =
            arr.find((a) => a.value == localStorage.getItem("AAcademy")) || "";
          if (defaultAca) setAcaID(defaultAca);
        }
        loadHostel(defaultAca, "");
      } else {
        loadHostel("", "");
      }
    });
  }, []);

  function loadHostel(academy, type) {
    setRowData([]);
    const temp = new FormData();
    if (isSuperAdmin && academy && academy.value) {
      temp.append("academy_id", academy.value);
    }
    // Only send the type when one is picked; the API filters on any value that
    // is set, so an empty type would otherwise return no rows.
    if (type) {
      temp.append("type", type);
    }
    temp.append("status", 1);

    listhostelentry(temp).then((res) => {
      if (res && res.status === true) {
        const data = (res.data || []).map((item) => ({
          ...item,
          role: roleLabel(item.role_id),
        }));
        setRowData(data);
      }
    });
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    loadHostel(e || "", htype);
  }

  function handleType(e) {
    setHType(e.target.value);
    loadHostel(acaid, e.target.value);
  }

  const exportToCSV = () => {
    const q = (v) => `"${(v == null ? "" : String(v)).replace(/"/g, '""')}"`;
    const header = columnDefs.map((c) => c.headerName);
    const lines = rowData.map((row) =>
      columnDefs.map((c) => q(row[c.field])).join(",")
    );
    const csv = [header.join(","), ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Hostel Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Hostel Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Hostel Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">Hostel Report</h2>
            </div>
            <div className="card-body">
              <div className="row">
                {isSuperAdmin && (
                  <div className="col-xl-4 col-sm-6">
                    <label className="form-label">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                    />
                  </div>
                )}

                <div className="col-xl-4 col-sm-6">
                  <label className="form-label">Type</label>
                  <select
                    className="default-select form-control wide"
                    value={htype}
                    onChange={handleType}
                  >
                    <option value="">All Types</option>
                    <option value="Boys">Boys</option>
                    <option value="Girls">Girls</option>
                  </select>
                </div>

                <div className="col-xl-4 col-sm-6">
                  <div className="res-right mt-5">
                    <button
                      className="btn btn-success me-2"
                      onClick={exportToCSV}
                      disabled={rowData.length === 0}
                    >
                      Excel Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HostelReport;
